module.exports = "<div class=\"filters\"></div>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader?interpolate!./src/components/filters/sample.html
// module id = 65
// module chunks = 0